import $ from 'jquery';
import './Pagination';

$('.product-finder-toggle').on('click', function (e){
    e.preventDefault();
    $.magnificPopup.open({
        items: {
            src: '#product-finder-popup'
        },
        type: 'inline'
    });
})

$('.product-finder__reset').on('click', function (e) {
    e.preventDefault()
    $(this).closest('.product-finder').find('select').val('').trigger('change');
});

// $('#list-product-finder').each(function () {
//     if($('#list-product-finder').hasClass('product-finder--scroll-down')) {
//         $([document.documentElement, document.body]).animate({
//             scrollTop: $(this).offset().top - $('.header__bottom').height() - 10
//         }, 500);
//     }
// })

$('.product-list').each(function () {
    new Pagination($(this), '.list-product--show');
    updateProductList($(this).find('.product-finder'));
})

$('.product-finder__select').on('change', function () {
    updateProductList($(this).closest('.product-finder'));
})

function updateProductList($productFinder) {
    var $productList =  $productFinder.closest('.product-list');
    var $products = $productList.find('.list-product')
    var filteredProducts = $products.toArray();

    filteredProducts = filterFinderType($productFinder.find('.product-finder__select--group'),'productgroup',filteredProducts);
    filteredProducts = filterFinderType($productFinder.find('.product-finder__select--application'),'applications',filteredProducts);
    filteredProducts = filterFinderType($productFinder.find('.product-finder__select--material'),'materials',filteredProducts);
    filteredProducts = filterFinderType($productFinder.find('.product-finder__select--feature'),'features',filteredProducts);

    $products.removeClass('list-product--show');
    filteredProducts.forEach(function (product) {
        $(product).addClass('list-product--show');
    })
    $productList.find('.product-list__product-count').text(filteredProducts.length)
    $productList.trigger('paginationUpdate');
}

function filterFinderType($elem,type,array) {
    if(array.length < 1 || $elem.length < 1) {
        return array;
    }
    var typeId = parseInt($elem.val().trim());
    if(isNaN(typeId)) {
        return array;
    }

    var index = 0;
    var newProducts = [];
    array.forEach(function (item) {
        var typeArray = String($(item).data(type)).split(",");
        typeArray = typeArray.map(function (item) {
            return parseInt(item.trim());
        });
        if($.inArray(typeId, typeArray) !== -1) {
            newProducts.push($(item));
        }
        index++;
    })
    return newProducts;
}
